import React from "react";
import { useLang } from "../context/LanguageContext";
import { BookOpen, Calculator, Hand, Globe2 } from "lucide-react";

const icons = [BookOpen, Calculator, Hand, Globe2];
const accents = ["#1E5FBA", "#FFD500", "#E63946", "#2E9E4E"];

const Program = () => {
  const { t } = useLang();
  return (
    <section id="programa" className="relative py-24 md:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="max-w-3xl">
          <div className="text-xs md:text-sm font-bold uppercase tracking-[0.25em] text-[#E63946] mb-4">
            {t.program.overline}
          </div>
          <h2 className="font-fredoka text-4xl md:text-5xl lg:text-6xl font-semibold leading-[1.05] text-[#1D3557]">
            {t.program.title}
          </h2>
          <p className="mt-6 text-lg md:text-xl leading-relaxed text-[#457B9D]">
            {t.program.body}
          </p>
        </div>

        <div className="mt-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
          {t.program.areas.map((a, i) => {
            const Icon = icons[i];
            return (
              <div
                key={i}
                data-testid={`program-area-${i}`}
                className="relative p-8 rounded-[2rem] border border-[#E2E8F0]/70 hover:-translate-y-1 transition-transform overflow-hidden group"
                style={{ background: `linear-gradient(180deg, ${accents[i]}10 0%, #FFFFFF 70%)` }}
              >
                <div
                  className="w-12 h-12 rounded-xl grid place-items-center mb-5"
                  style={{ backgroundColor: accents[i] }}
                >
                  <Icon className="w-6 h-6 text-white" strokeWidth={2.5} />
                </div>
                <h3 className="font-fredoka text-xl font-semibold text-[#1D3557] mb-2">{a.title}</h3>
                <p className="text-[#457B9D] text-sm leading-relaxed">{a.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Program;
